
import Vue, { PropType } from 'vue';
import { get } from 'lodash';
import IconButton from '@/common/icon-button/IconButton.vue';
import { Icon } from '@/common/icon/Icon.vue';
import Api from '@/core/api';
import { Unsubscriber } from '@/core/event-bus';
import { PlayerState } from '@/core/player-state';

interface PlayStopToggleConfig {
    seekToLiveOnPlay: boolean,
}

export default Vue.extend({

    components: {
        IconButton
    },
    props: {
        api: {
            type: Object as PropType<Api>,
            required: true,
        },
        config: {
            type: Object as PropType<PlayStopToggleConfig>,
            default: () => ({} as PlayStopToggleConfig)
        },
        labels: {
            type: Object as PropType<Record<string, string>>,
            default: () => ({})
        },
        isLeft: {
            type: Boolean as PropType<boolean>,
            default: false
        }
    },

    data() {
        return {
            isPlaying: false,
            videoDurationSecs: 0,
            unsubscribers: [] as Unsubscriber[]
        };
    },

    computed: {
        icon(): Icon {
            return this.isPlaying ? Icon.stop : Icon.play;
        },
        seekToLiveOnPlay(): boolean {
            return this.config.seekToLiveOnPlay;
        }
    },

    mounted() {
        const { unsubscriber, state } = this.api.onStateChange(this.onStateChange);
        this.onStateChange(state);
        this.unsubscribers.push(unsubscriber);
    },

    beforeDestroy() {
        for (const unsubscriber of this.unsubscribers) {
            if (typeof unsubscriber === 'function') {
                unsubscriber();
            }
        }
    },

    methods: {
        onStateChange(state: Partial<PlayerState>) {
            this.isPlaying = get(state, 'isPlaying', this.isPlaying);
            this.videoDurationSecs = get(state, 'videoDurationSecs', this.videoDurationSecs);
        },

        togglePlayStop() {
            if (this.isPlaying) {
                console.debug('[PlayStopToggle] pause');
                this.api.pause();
            } else {
                if (this.seekToLiveOnPlay && this.videoDurationSecs > 1) {
                    // for live streams, to prevent playing some old segments on resume, we seek to the current live position
                    console.log('[PlayStopToggle] seeking to live position');
                    this.api.seek(this.videoDurationSecs - 1);
                }
                this.api.play();
            }
        }
    }
});
